<script>
  import { Link, useLocation } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  import SideNavFlyoutMenu from "./SideNavFlyoutMenu.svelte";

  const location = useLocation();
  const items = [
    { label: "Company Info", href: ROUTES.dam.companySettings.companyInfo, icon: "company-info" },
    { label: "Orga Framework", href: ROUTES.dam.companySettings.organizationFramework, icon: "organization-framework" },
    { label: "Process Framework", href: ROUTES.dam.companySettings.processFramework, icon: "process-framework" },
  ];
  let open = false;

  $: currentPath = ($location?.pathname || "").replace(/\/+$/, "");
  $: active = currentPath.startsWith(ROUTES.dam.companySettings.root);
</script>

<SideNavFlyoutMenu bind:open {active} ariaLabel="Open Company Settings menu" tooltip="Company Settings">
  <svelte:fragment slot="trigger">
    <span class="company-settings-trigger-icon" aria-hidden="true" />
    <span class="company-settings-trigger-label">Company Settings</span>
  </svelte:fragment>
  {#each items as item}
    <Link
      to={item.href}
      class={`side-nav-flyout-item${
        currentPath === item.href ? " active" : ""
      }`}
      aria-current={currentPath === item.href ? "page" : undefined}
      on:click={() => (open = false)}
    >
      <span class={`company-settings-item-icon ${item.icon}`} aria-hidden="true" />
      {item.label}
    </Link>
  {/each}
</SideNavFlyoutMenu>

<style>
  .company-settings-trigger-icon {
    display: inline-block;
    flex: 0 0 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
    background: var(--pax-black);
    mask: url("/img/assistant/icons/settings.svg") center / 1.25rem no-repeat;
    -webkit-mask: url("/img/assistant/icons/settings.svg") center / 1.25rem no-repeat;
  }

  .company-settings-trigger-label {
    display: none;
    overflow: hidden;
    font-size: .75rem;
    font-weight: 300;
    line-height: .8rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :global(.app-side-nav.expanded) .company-settings-trigger-label {
    display: block;
  }

  .company-settings-item-icon {
    display: inline-block;
    flex: 0 0 1rem;
    width: 1rem;
    height: 1rem;
    background: currentColor;
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: contain;
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: contain;
  }

  .company-settings-item-icon.company-info {
    mask-image: url("/img/assistant/icons/info.svg");
    -webkit-mask-image: url("/img/assistant/icons/info.svg");
  }

  .company-settings-item-icon.organization-framework {
    mask-image: url("/img/assistant/icons/account_tree.svg");
    -webkit-mask-image: url("/img/assistant/icons/account_tree.svg");
  }

  .company-settings-item-icon.process-framework {
    mask-image: url("/img/assistant/icons/route.svg");
    -webkit-mask-image: url("/img/assistant/icons/route.svg");
  }
</style>
